// extracted by mini-css-extract-plugin
module.exports = {"blogLogo":"collections_blogLogo__V28qy"};